import { SparklesIcon } from "@heroicons/react/24/solid";

import { clsxMerge } from "shared/lib/helpers";
import CircularLoading from "@/components/base/circular-loading";
import { BorderWithGradient } from "shared/ui/border-with-gradient";
import { useEmailTemplatesContext } from "@/modules/email-templates-sidebar/context";
import { CUSTOM_EVENTS } from "@/constants/custom-events";
import { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";

export const GenereateAIEmailButton = ({
  className,
}: {
  className?: string;
}) => {
  const { handleComposeWithAI, isAIGenerationStarted } =
    useEmailTemplatesContext();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(isAIGenerationStarted);
  }, [isAIGenerationStarted]);

  const handleOnPrompttBlurEffect = () => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  const throttledOnPrompttBlurEffect = useCallback(
    debounce(handleOnPrompttBlurEffect, 5000, {
      leading: true,
      trailing: false,
    }),
    []
  );

  const handleOnClick = () => {
    handleComposeWithAI();
  };

  useEffect(() => {
    const handleOnBlur = () => {
      throttledOnPrompttBlurEffect();
    };

    window.document.addEventListener(
      CUSTOM_EVENTS.ACCOUNT.EMAIL_TEMPLATES.PROMT_BLUR,
      handleOnBlur
    );

    return () => {
      window.document.removeEventListener(
        CUSTOM_EVENTS.ACCOUNT.EMAIL_TEMPLATES.PROMT_BLUR,
        handleOnBlur
      );
    };
  }, []);

  return (
    <BorderWithGradient
      className="group rounded-[5px] px-2 py-0"
      containerClassName="rounded-md p-[1px]"
    >
      <button
        type="button"
        className={clsxMerge(
          "transition-all duration-300",
          "btn-ae border-none text-transparent typography-header-8-semibold",
          "text-gradient flex-nowrap whitespace-nowrap",
          isLoading && "opacity-80",
          className
        )}
        disabled={isLoading}
        onClick={handleOnClick}
      >
        {isLoading ? (
          <CircularLoading className="mr-2 w-4 text-[#714CC9] transition-all duration-300 group-hover:text-[#CC3997]" />
        ) : (
          <SparklesIcon
            className={clsxMerge(
              "transition-all duration-300",
              "mb-1 mr-2 w-4",
              "scale-100 text-[#714CC9]",
              "group-hover:-scale-125 group-hover:text-[#CC3997]"
            )}
          />
        )}
        <span
          className={clsxMerge(
            !isLoading &&
              "text-gradient translate-x-0 transition-all duration-300 group-hover:translate-x-2",
            !isLoading && "group-hover:text-gradient-reverse"
          )}
        >
          Compose with AI
        </span>
      </button>
    </BorderWithGradient>
  );
};
